<template lang="pug">
  b-modal#editProxy(
  ref="editProxy"
  :title="$t('ui.combine.edit_proxy')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.proxy_id')").mb-0
        div.form-control.form-control-sm.disabled {{ getProxyId }}
      b-form-group(:label="$t('ui.proxy_host')").mb-0
        div.form-control.form-control-sm.disabled {{ getProxyHost }}
        //- DebounceInput(
        //-   size="sm"
        //-   ref="dataEdit_proxyHost"
        //-   required
        //-   type="text"
        //-   :dirty="$v.dataEdit_proxyHost.$dirty"
        //-   :error="$v.dataEdit_proxyHost.$error"
        //-   v-model.trim.lazy="$v.dataEdit_proxyHost.$model"
        //-   :disabled="true"
        //-   @focus.native="$event.target.select()"
        //-   :maxLength="$v.dataEdit_proxyHost.$params.maxLength.max"
        //- )
        //- ValidateResult(:value="$v.dataEdit_proxyHost" :name="$t('ui.proxy_host')")
      b-form-group(:label="$t('ui.proxy_port')").mb-0
        div.form-control.form-control-sm.disabled {{ getProxyPort }}
        //- DebounceInput(
        //-   size="sm"
        //-   ref="dataEdit_proxyPort"
        //-   type="text"
        //-   :dirty="$v.dataEdit_proxyPort.$dirty"
        //-   :error="$v.dataEdit_proxyPort.$error"
        //-   v-model.trim.lazy="$v.dataEdit_proxyPort.$model"
        //-   :disabled="true"
        //-   @focus.native="$event.target.select()"
        //-   :maxLength="$v.dataEdit_proxyPort.$params.maxLength.max"
        //- )
        //- ValidateResult(:value="$v.dataEdit_proxyPort" :name="$t('ui.proxy_port')")
      b-form-group(:label="$t('ui.remark')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_proxyRemark"
          type="text"
          :dirty="$v.dataEdit_proxyRemark.$dirty"
          :error="$v.dataEdit_proxyRemark.$error"
          v-model.trim.lazy="$v.dataEdit_proxyRemark.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
          :maxLength="$v.dataEdit_proxyRemark.$params.maxLength.max"
        )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, ipAddress, numeric, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    proxyID: "",
    proxyHost: "",
    proxyPort: "",
    proxyRemark: ""
  },
  data() {
    return {
      dataEdit_proxyHost: "",
      dataEdit_proxyPort: "",
      dataEdit_proxyRemark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getProxyId: function() {
      return this.proxyID;
    },
    getProxyHost: function() {
      return this.proxyHost;
    },
    getProxyPort: function() {
      return this.proxyPort;
    }
  },
  validations: {
    dataEdit_proxyRemark: {
      maxLength: maxLength(255)
    }
  },
  watch: {
    proxyRemark: function(newVal) {
      this.dataEdit_proxyRemark = newVal;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editProxyUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.proxy,
          target_proxy_id: this.proxyID,
          remark: this.dataEdit_proxyRemark
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.proxyID, this.proxyHost, this.proxyPort, this.dataEdit_proxyRemark);
                  this.$refs.editProxy.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_proxy", this.feedback.status);
                  this.$refs.editProxy.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      // this.dataEdit_proxyHost = this.proxyHost;
      // this.dataEdit_proxyPort = this.proxyPort;
      this.dataEdit_proxyRemark = this.proxyRemark;
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataEdit_proxyRemark.$el.focus();
    }
  }
};
</script>
